import { useQuery } from '@tanstack/react-query'
import { authFetchJson } from '@/shared/lib/auth-fetch'

export const useAdminsAndBaseLeaders = () => {
    const query = useQuery({
        queryKey: ['admins-base-leaders'],
        queryFn: async () => {
            // Fetch users with Admin (roleId=1) and BaseLeader (roleId=2) roles
            const res = await authFetchJson<any[]>('/user/by-role?roleId=1,2')
            if (!res.success) {
                throw new Error(res.message || 'Failed to fetch admins and base leaders')
            }
            return res
        },
    })
    return query
}


